import { useQueryClient } from '@tanstack/react-query';
import { useBoolean } from '@gov-nx/utils/common';
import { invalidateMySubmissionDetailQuery } from './queries';
import type { ConnectToAnotherSubmissionMutation } from './useConnectToAnotherSubmissionMutation';
import { useConnectToAnotherSubmissionMutation } from './useConnectToAnotherSubmissionMutation';
import type { DisconnectFromAnotherSubmissionMutation } from './useDisconnectFromSubmissionMutation';
import { useDisconnectFromSubmissionMutation } from './useDisconnectFromSubmissionMutation';

export interface SubmissionConnection {
	disconnect: DisconnectFromAnotherSubmissionMutation;
	isConnected: boolean;
	connect: ConnectToAnotherSubmissionMutation;
}

interface Props {
	submissionId: number;
}

export const useSubmissionConnection = ({
	submissionId,
}: Props): SubmissionConnection => {
	const queryClient = useQueryClient();

	const isDisconnected = useBoolean();

	const disconnectMutation = useDisconnectFromSubmissionMutation(
		isDisconnected.setTrue
	);
	const connectMutation = useConnectToAnotherSubmissionMutation(async () => {
		await invalidateMySubmissionDetailQuery(queryClient, submissionId);
		isDisconnected.setFalse();
	});

	return {
		isConnected: isDisconnected.isFalse,
		disconnect: disconnectMutation,
		connect: connectMutation,
	};
};
